import {defineNuxtPlugin, onNuxtReady} from 'nuxt/app';

/**
 * Used for TAs to wait for app to be interactive.
 *
 * See https://nuxt.com/docs/api/advanced/hooks.
 */
export default defineNuxtPlugin((nuxtApp) => {
    const root = document.documentElement;
    let isReady = false;
    const setMarker = () => {
        if (isReady) {
            root.setAttribute('data-nuxt-page-finish', '');
        }
    };

    // Not page:loading:start: NuxtPage fires it on every page-key change with no end, so the marker would stay cleared.
    nuxtApp.hook('page:start', () => {
        root.removeAttribute('data-nuxt-page-finish');
    });
    nuxtApp.hook('page:finish', setMarker);
    nuxtApp.hook('page:loading:end', setMarker);

    /**
     * Add a data-nuxt-page-finish attribute to html element when app is fully hydrated
     */
    onNuxtReady(() => {
        isReady = true;
        root.setAttribute('data-nuxt-page-finish', '');
    });
});
